<template>
    <div class="lime-body">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                        <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :on-cancel="onCancel"
                :is-full-page="fullPage"></loading>
                <p style="color:red;text-align:center">{{ errorMessage }}</p>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb breadcrumb-separator-1">
                                    <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
                                    <li class="breadcrumb-item active" aria-current="page">Search Result</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">User List</h5>
                                    <div class="table-responsive">

                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">User Name</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="resultData.usersResults.length">
                                                <tr v-for="(getAllUser, index, key) in resultData.usersResults">
                                                    <td>{{getAllUser.name}}</td>
                                                    <td><span class="badge badge-success">{{getAllUser.status}}</span></td>
                                                    <!-- <td><button class="badge badge-info">View Detail</button></td> -->
                                                    <td><router-link :to="{ name: 'userDetail', params: { userId: getAllUser.uid, page: 'dashboard' }}"><button class="badge badge-info">View Details</button></router-link></td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td>No Data Found</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>      
                                </div>
                            </div>

                        </div>

                     


                        <div class="col-md-6" v-if="isAdmin">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Brand List</h5>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Brand Name</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="resultData.brandsResults.length">
                                                <tr v-for="(getAllBrand, index, key) in resultData.brandsResults">
                                                    <td>{{getAllBrand.brand_name}}</td>
                                                    <td><span class="badge badge-success">{{getAllBrand.status}}</span></td>
                                                    <!-- <td><button class="badge badge-info">View Detail</button></td> -->
                                                    <td><router-link :to="{ name: 'brandDetail', params: { brandId: getAllBrand.uid, page: 'dashboard'}}"><button class="badge badge-info">View Details</button></router-link></td>
                                                </tr>
                                                
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                  <td>No Data Found</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">
                                       Invoice List
                                    </h5>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Invoice ID</th>
                                                    <th scope="col">Brands</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="resultData.invoicesResults.length">
                                              <tr v-for="(invoiceData, index, key) in resultData.invoicesResults">
                                                 <td>{{invoiceData.invoice_number}}</td>
                                                 <td>{{invoiceData.brand_name}}</td>
                                                 <td><router-link :to="{ name: 'invoiceDetail', params: { invoiceId: invoiceData.uid, page: 'dashboard'}}"><button class="badge badge-info">View Details</button></router-link></td>
                                              </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                  <td>No Data Found</td>
                                                </tr>
                                            </tbody>
                                            
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6" v-if="isAdmin">
                            <div class="card">
                                <div class="card-body">
                                    <!-- <h5 class="card-title">Last Payment</h5> -->
                                    <div class="table-responsive">
                                        <table class="table">
                                            <!-- <thead>
                                                <tr>
                                                    <th scope="col">Invoice ID</th>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead> -->
                                            <!-- <tbody>
                                                <tr v-for="(lastPayment, index, key) in lastPayments">
                                                    <td>{{key}}</td>
                                                    <td>{{lastPayment.amount}}</td>
                                                    <td><button class="badge badge-info">View Details</button></td>
                                                </tr>
                                            </tbody> -->
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="isUser">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">
                                       Invoice List
                                    </h5>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Invoice ID</th>
                                                    <th scope="col">Brands</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="resultData.invoicesResults.length">
                                              <tr v-for="(invoiceData, index, key) in resultData.invoicesResults">
                                                 <td>{{invoiceData.stripe_invoice_id}}</td>
                                                 <td>{{invoiceData.brand_name}}</td>
                                                 <td><router-link :to="{ name: 'invoiceDetail', params: { invoiceId: invoiceData.uid, page: 'dashboard'}}"><button class="badge badge-info">View Details</button></router-link></td>
                                              </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                  <td>No Data Found</td>
                                                </tr>
                                            </tbody>
                                            
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                       
                    </div>
                    
                </div>
                
        </div>
        
    </div>     
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'SearchData',
  components: {
    Loading
  },
  data () {
    return {
      isLoading: false,
      errorMessage: '',
      fullPage: true,
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      BrandDatas: [],
      getAllUsers: [],
      getAllBrands: [],
      getAllInvoices: [],
      resultData: [],
      Invoices: [],
      role: localStorage.getItem('role')
    }
  },
  computed: {
    isAdmin () {
      return this.role && this.role === 'admin'
    },
    isUser () {
      return this.role && this.role === 'user'
    }
  },
  methods: {
    getSearchData () {
      var jwttoken = localStorage.getItem('jwt')
      var uid = localStorage.getItem('uid')
      console.log('uid')
      var search = this.$router.currentRoute.query.text
      this.isLoading = true
      axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/globalSearch',
        {
          text: search,
          userId: uid
        }, {
          headers: {
            'x-access-token': jwttoken
          }})
        .then(response => {
          // console.log(response)
          this.resultData = response.data.results
          console.log(this.resultData)
          this.isLoading = false
          // localStorage.setItem('searchData', JSON.stringify(this.resultData))
          // // console.log(this.$router.currentRoute.name)
          // this.$router.push('/searchData?text=nike')
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    getInvoices () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.Invoices = response.data.results
          this.isLoading = false
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    getUsers () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.getAllUsers = response.data.results[0]
          this.isLoading = false
          console.log(response)
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    getbrands () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.getAllBrands = response.data.results[0]
          this.isLoading = false
          console.log(response)
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    }
  },
  watch: {
    $route (to, from) {
      this.getSearchData()
    }
  },
  created () {
  },
  mounted () {
    this.getInvoices()
    this.getUsers()
    this.getbrands()
    this.getSearchData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/SearchData.vue